// extracted by mini-css-extract-plugin
module.exports = {"root":"WModal_root__1yqoz","rotation":"WModal_rotation__S3_mQ"};